import { useEffect, useState } from "react";
import { Loader2, Phone, Mail, Home } from "lucide-react";
import { api, fmtDate, waLink } from "@/lib/api";
import { WhatsAppIcon } from "@/components/WhatsAppFloat";

const LeadsTab = () => {
  const [leads, setLeads] = useState(null);

  useEffect(() => {
    api
      .get("/admin/leads")
      .then((r) => setLeads(r.data))
      .catch(() => setLeads([]));
  }, []);

  return (
    <div>
      <h2 className="font-serif text-2xl text-ivory">Mensajes de clientes</h2>
      {leads === null && (
        <div className="mt-10 flex justify-center">
          <Loader2 className="animate-spin text-gold" size={28} />
        </div>
      )}
      {leads && leads.length === 0 && (
        <p className="mt-10 rounded-xl border border-gold/15 bg-ink2/60 p-8 text-center text-stone2" data-testid="admin-leads-empty">
          Todavía no hay mensajes. Cuando un cliente rellene el formulario de la web, aparecerá aquí.
        </p>
      )}
      <div className="mt-6 space-y-4">
        {leads &&
          leads.map((l) => (
            <div key={l.id} data-testid={`lead-card-${l.id}`} className="rounded-xl border border-gold/15 bg-ink2/70 p-5">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <p className="font-medium text-ivory">
                  {l.name} <span className="text-xs text-stone2">· {fmtDate(l.created_at)}</span>
                </p>
                <div className="flex gap-2">
                  <a href={`tel:${l.phone}`} data-testid={`lead-phone-${l.id}`} className="flex items-center gap-1.5 rounded-full border border-gold/25 px-3.5 py-1.5 text-xs text-gold hover:bg-gold/10">
                    <Phone size={12} /> {l.phone}
                  </a>
                  <a
                    href={waLink(`Hola ${l.name}, soy Inmobiliaria Tecnohogar. Te escribo por tu consulta en la web.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`lead-whatsapp-${l.id}`}
                    className="flex items-center gap-1.5 rounded-full bg-wa/15 px-3.5 py-1.5 text-xs text-wa hover:bg-wa/25"
                  >
                    <WhatsAppIcon className="h-3.5 w-3.5" /> Responder
                  </a>
                </div>
              </div>
              {l.email && (
                <p className="mt-2 flex items-center gap-2 text-sm text-stone2">
                  <Mail size={13} className="text-gold-subtle" /> {l.email}
                </p>
              )}
              {l.property_title && (
                <p className="mt-2 flex items-center gap-2 text-sm text-gold/80">
                  <Home size={13} /> Interés: {l.property_title}
                </p>
              )}
              {l.message && <p className="mt-3 whitespace-pre-line rounded-lg bg-ink/60 p-4 text-sm leading-relaxed text-ivory/85">{l.message}</p>}
            </div>
          ))}
      </div>
    </div>
  );
};

export default LeadsTab;
